import { Inject, Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { config } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class MqService {
  readonly desktopMediaQuery = config.desktopMediaQuery || '(min-width: 768px)';
  readonly tabletMediaQuery = '(min-width: 1024px)';

  constructor(
    private bpObserver: BreakpointObserver,
    @Inject('Window') window: Window
  ) { }

  mqFactory(mediaQuery: string) {
    return (left: () => void, right: () => void): Subscription => {
      return this.bpObserver
        .observe(mediaQuery)
        .subscribe((state: BreakpointState) => {
          return state.matches ? right() : left();
        });
    }
  }

  mobileDesktop(mobile: () => void, desktop: () => void) {
    return this.mqFactory(this.desktopMediaQuery)(mobile, desktop);
  }

  tabletDesktop(tablet: () => void, desktop: () => void) {
    return this.mqFactory(this.tabletMediaQuery)(tablet, desktop);
  }

  isTabletAndLaptop() {
    return window.innerWidth > 768 && window.innerWidth < 1440;
  }

  isTablet() {
    return window.innerWidth > 768 && window.innerWidth < 1024;
  }

  isMidi() {
    return window.innerWidth <= 1024;
  }
}
